import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HasPermission } from 'Core/security';

// Netradyne console served under monarchtracking.com, which allows iframe embedding
// (idms.netradyne.com blocks it via CSP frame-ancestors)
const NETRADYNE_URL = 'https://driveri.monarchtracking.com/console/#/login?redirectUrl=%2F';

const NetradyneView = () => {
  const navigate = useNavigate();
  const user = useSelector(state => state.securityRedux.user);

  useEffect(() => {
    if (!HasPermission(user, 'mnetradyne')) {
      navigate('/error');
    }
  }, [user, navigate]);

  return (
    <div style={{ height: '98vh' }}>
      <iframe
        id="netradyne"
        title="Netradyne Cams"
        loading="lazy"
        width="100%"
        height="100%"
        src={NETRADYNE_URL}
      />
    </div>
  );
};

export default NetradyneView;
